import { rem, rgba } from 'polished';
import styled from 'styled-components';

export const StyledBody = styled.div`
  padding: ${rem('16px')};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.m}) {
    position: relative;
    z-index: 101;
    padding: ${rem('32px')} ${rem('53px')};
    background: ${({ theme }) =>
      `linear-gradient(90deg, 
        ${theme.colors.main} 30%, 
        ${rgba(theme.colors.main, 0.5)} 45%, 
        ${rgba(theme.colors.main, 0)} 60%)`};
  }
`;

export const StyledCtaButtonWrapper = styled.div`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.m}) {
    max-width: ${rem('265px')};
  }
`;

export const StyledImage = styled.img`
  display: block;
  width: 100%;
  height: auto;
`;

export const StyledImageWrapper = styled.div`
  display: none;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.m}) {
    position: absolute;
    top: 50%;
    right: 0;
    left: 0;
    z-index: 100;
    display: block;
    transform: translateY(-50%);
  }
`;

export const StyledInnerWrapper = styled.div`
  position: relative;
  border: 1px solid ${({ theme }) => rgba(theme.colors.cross.silverFox, 0.5)};
  border-radius: ${rem('16px')};
  overflow: hidden;
`;

export const StyledText = styled.div`
  margin: ${rem('-20px')} 0 ${rem('16px')} 0;
  color: ${({ theme }) => theme.colors.cross.black};
  font-size: ${rem('16px')};
  font-weight: 400;
  line-height: 1.4;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.m}) {
    margin: ${rem('-28px')} 0 ${rem('40px')} 0;
  }

  p,
  ol,
  ul {
    &:first-child {
      margin-top: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
`;
